import { Typography } from '@mui/material';

type Props = {
    title: string;
};

export const OrbitSectionHeader = ({ title }: Props) => (
    <Typography sx={{ fontWeight: 'bold', color: '#000' }}>{title}</Typography>
);
